import React from 'react';

const FILTERS = [
  { id: 'all', label: 'Tous' },
  { id: 'pending', label: 'À répondre' },
  { id: 'published', label: 'Publiés' },
];

export default function ReviewFilterPills({
  activeFilter = 'all',
  onChange,
  counts = { all: 0, pending: 0, published: 0 },
  disabled = false,
}) {
  return (
    <div style={styles.row} role="tablist" aria-label="Filtrer les avis">
      {FILTERS.map((f) => {
        const isActive = activeFilter === f.id;
        const isDisabled = disabled && f.id !== 'all';
        const count = counts?.[f.id] ?? 0;
        return (
          <button
            key={f.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            disabled={isDisabled}
            onClick={() => { if (!isDisabled && typeof onChange === 'function') onChange(f.id); }}
            style={{
              ...styles.pill,
              ...(isActive ? styles.pillActive : styles.pillInactive),
              ...(isDisabled ? styles.pillDisabled : null),
            }}
          >
            {f.label} ({count})
          </button>
        );
      })}
    </div>
  );
}

const styles = {
  row: {
    display: 'flex',
    gap: 8,
    padding: '8px 16px 12px',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
  },
  pill: {
    flexShrink: 0,
    padding: '8px 14px',
    borderRadius: 999,
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 120ms ease',
    fontFamily: 'inherit',
    whiteSpace: 'nowrap',
  },
  pillActive: {
    background: '#E8502A',
    color: '#FFFFFF',
    border: '1px solid #E8502A',
  },
  pillInactive: {
    background: '#FFFFFF',
    color: '#1A1A1A',
    border: '1px solid #EDEAE3',
  },
  pillDisabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
};
